import { toast } from "sonner";
import { CheckCircle, XCircle, Info } from "lucide-react";

export const showSuccess = (msg: string) =>
    toast.success(
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {/* <CheckCircle size={20} color="#059669" /> */}
            <span style={{ fontWeight: 600 }}>{msg}</span>
        </div>
    );

export const showError = (msg: string) =>
    toast.error(
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {/* <XCircle size={20} color="#dc2626" /> */}
            <span style={{ fontWeight: 600 }}>{msg}</span>
        </div>
    );

export const showInfo = (msg: string) =>
    toast.info(
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {/* <Info size={20} color="#2563eb" /> */}
            <span style={{ fontWeight: 600 }}>{msg}</span>
        </div>
    );






//     import { toast } from "sonner";
// import { CheckCircle, XCircle, Info } from "lucide-react";

// const baseStyle = {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     gap: "12px",
//     width: "100%",
// };

// const messageStyle = { fontWeight: 600 };

// const cancelButtonStyle = {
//     // background: "#e5e7eb",
//     color: "#111",
//     border: "none",
//     padding: "4px 10px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     fontWeight: 500,
// };

// export const showSuccess = (msg: string) =>
//     toast.custom((t) => (
//         <div style={baseStyle}>
//             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <CheckCircle size={20} color="#059669" />
//                 <span style={messageStyle}>{msg}</span>
//             </div>
//             <button
//                 style={cancelButtonStyle}
//                 onClick={() => toast.dismiss(t)}
//             >
//                 Cancel
//             </button>
//         </div>
//     ));

// export const showError = (msg: string) =>
//     toast.custom((t) => (
//         <div style={baseStyle}>
//             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <XCircle size={20} color="#dc2626" />
//                 <span style={messageStyle}>{msg}</span>
//             </div>
//             <button
//                 style={{ ...cancelButtonStyle, background: "#fecaca", color: "#991b1b" }}
//                 onClick={() => toast.dismiss(t)}
//             >
//                 Cancel
//             </button>
//         </div>
//     ));

// export const showInfo = (msg: string) =>
//     toast.custom((t) => (
//         <div style={baseStyle}>
//             <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <Info size={20} color="#2563eb" />
//                 <span style={messageStyle}>{msg}</span>
//             </div>
//             <button
//                 style={{ ...cancelButtonStyle, background: "#bfdbfe", color: "#1e3a8a" }}
//                 onClick={() => toast.dismiss(t)}
//             >
//                 Cancel
//             </button>
//         </div>
//     ));
